var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFooterFixedYoutube = function SvgIconFooterFixedYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M15.314 4.608a1.765 1.765 0 0 0-1.243-1.246c-1.095-.294-5.491-.294-5.491-.294s-4.393 0-5.491.294a1.765 1.765 0 0 0-1.243 1.246C1.553 5.707 1.553 8 1.553 8s0 2.293.293 3.391a1.765 1.765 0 0 0 1.243 1.246c1.098.294 5.491.294 5.491.294s4.396 0 5.491-.294a1.765 1.765 0 0 0 1.243-1.246c.293-1.098.293-3.391.293-3.391s0-2.293-.293-3.392Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.176 10.113 10.827 8 7.176 5.886v4.227Z"
  })));
};
export default SvgIconFooterFixedYoutube;